import * as yup from "yup";

import type { Currency } from "@krea/shared/types/common";

import { BidTypeEnum } from "@/features/common/enums";
import type { IPurchaseFinancingBidInput } from "@/features/lender-responses/types/lender-response";

import { AdministrationFeesValidation } from "../utils/validators/AdministrationFeesValidation";
import { AmountValidation } from "../utils/validators/AmountValidation";
import { LenderMonthlyInterestValidation } from "../utils/validators/LenderMonthlyInterestValidation";
import { SetupFeeValidation } from "../utils/validators/SetupFeeValidation";

export const purchaseFinancingBidSchema: (
  currency: Currency,
  formatWithCurrency: (value: number) => string,
) => yup.ObjectSchema<IPurchaseFinancingBidInput> = (
  currency,
  formatWithCurrency,
) =>
  yup.object().shape({
    type: yup
      .string()
      .required("Type is required")
      .oneOf([BidTypeEnum.PURCHASE_FINANCING])
      .default(BidTypeEnum.PURCHASE_FINANCING),
    amount: AmountValidation(currency, formatWithCurrency),
    lenderMonthlyInterest: LenderMonthlyInterestValidation({
      isFunction: () => true,
    }).required(),
    limitFeePerYear: yup.number().optional().nullable(),
    paybackTimeDays: yup
      .number()
      .typeError("Payback time (days) is required")
      .required("Payback time (days) is required")
      .integer("Must be a whole number")
      .min(1, (schema) => `Payback time can't be lower than ${schema.min} day`),
    setupFee: SetupFeeValidation(formatWithCurrency),
    administrationFees: AdministrationFeesValidation(formatWithCurrency, {
      boundByApprovedAmount: true,
    }),
  });

export const purchaseFinancingBidDefaultValues: IPurchaseFinancingBidInput = {
  type: BidTypeEnum.PURCHASE_FINANCING,
  amount: undefined,
  lenderMonthlyInterest: undefined,
  limitFeePerYear: undefined,
  paybackTimeDays: undefined,
  setupFee: undefined,
  administrationFees: undefined,
};
